// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GnkY","toggleWrap":"styles_toggleWrap__3H5yH","content":"styles_content__1BZ4a","selectAreaCode":"styles_selectAreaCode__2X-aH"};